import React, { useContext, useState } from "react";
import { Intro } from "components/commons";
import locale from "localization";
import ShiftRecordsFilter from "./shift-records-filter";
import { getShifts, updateShiftById } from "apis/shift-records.api";
import { shiftRecordColumns } from "./shift-records-column";
import { initialFilterState } from "./shift-records-filter.state";
import { mapFilterToRequest, mapDataToList } from "./shift-records.mapper";
import useDataTable from "hooks/useDataTable";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { useRouter, useModal, useApi } from "hooks";
import { StationContext } from "contexts";
import { SuccessModal } from "components/modals";
import { StocqClockIn } from "images";

const ShiftRecordsModule = () => {
  const { station } = useContext(StationContext);
  const { history } = useRouter();
  const prevShiftModal = useModal();
  const syncRequiredModal = useModal();
  const reopenConfirmModal = useModal();
  const reopenSuccessModal = useModal();
  const [reopenShiftId, setReopenShiftId] = useState(null);

  const showPrevModal = () => {
    prevShiftModal.show();
  };

  const showSyncModal = () => {
    syncRequiredModal.show();
  };

  const showReopenModal = (shiftId) => {
    setReopenShiftId(shiftId);
    reopenConfirmModal.show();
  };

  const { filter, table } = useDataTable({
    api: {
      api: getShifts,
      params: {
        page: 1,
        perPage: 10,
        stationCode: station.stationCode,
      },
      mapper: (param) => {
        return param;
      },
    },
    filter: { initialState: initialFilterState(), mapper: mapFilterToRequest },
    table: {
      key: "shifts",
      mapper: (shifts) =>
        mapDataToList({
          shifts,
          history,
          showPrevModal,
          showSyncModal,
          showReopenModal,
        }),
      columns: shiftRecordColumns,
    },
  });

  const { refetch } = table;

  const reopenShift = useApi({
    api: updateShiftById,
    handleOwnError: true,
    params: { shiftId: reopenShiftId },
  });

  const handleReopen = async () => {
    await reopenShift.request({ status: "ended" });
    reopenConfirmModal.close();
    reopenSuccessModal.show();
  };

  return (
    <>
      <SuccessModal
        image={StocqClockIn}
        title={locale.shiftSyncRequired}
        content={locale.onlyEndedShifts}
        {...syncRequiredModal}
        close={() => syncRequiredModal.close()}
        primary={{
          text: locale.gotIt,
          onClick: () => syncRequiredModal.close(),
        }}
      />
      <SuccessModal
        image={StocqClockIn}
        title={locale.prevShiftNotClosed}
        content={locale.thisShiftCannotBeEdited}
        {...prevShiftModal}
        close={() => prevShiftModal.close()}
        primary={{
          text: locale.gotIt,
          onClick: () => prevShiftModal.close(),
        }}
      />
      {/* Reopen confirmation modal */}
      <SuccessModal
        image={StocqClockIn}
        title={locale.reopenShift}
        content={locale.reopenShiftContent}
        centerButtons
        loading={reopenShift.loading}
        {...reopenConfirmModal}
        close={() => reopenConfirmModal.close()}
        secondary={{
          text: locale.cancel,
          onClick: () => reopenConfirmModal.close(),
        }}
        primary={{
          text: locale.reopen,
          onClick: handleReopen,
        }}
      />
      {/* Reopen success modal */}
      <SuccessModal
        image={StocqClockIn}
        title={locale.reopenShift}
        content={locale.reopenShiftSuccessContent}
        {...reopenSuccessModal}
        close={() => {
          reopenSuccessModal.close();
          refetch();
        }}
        primary={{
          text: locale.gotIt,
          onClick: () => {
            reopenSuccessModal.close();
            refetch();
          },
        }}
      />
      <div>
        <Intro title={locale.shiftRecords} />
        <ShiftRecordsFilter {...filter} />
        <DataTableV2 {...table} />
      </div>
    </>
  );
};

export default ShiftRecordsModule;
